export const TOGGLE_CHECKED = 'TOGGLE_CHECKED';
// Add other existing action types here if this file already exists
export const SET_RECEIVER_ID = 'SET_RECEIVER_ID';
export const SET_CHECKED_FALSE = 'SET_CHECKED_FALSE';